export var TrackingSourceEnum;
(function (TrackingSourceEnum) {
    TrackingSourceEnum["ELD"] = "ELD";
    TrackingSourceEnum["MobileApp"] = "Mobile App";
})(TrackingSourceEnum || (TrackingSourceEnum = {}));
